export enum Encodings {
	UTF_8 = 'UTF_8',
	UTF_8_BOM = 'UTF_8_BOM',
	ISO_8859_15 = 'ISO_8859_15',
	ISO_8859_1 = 'ISO_8859_1',
	WINDOWS_1252 = 'WINDOWS_1252',
	IBM_850 = 'IBM_850'
}
